import ArrowUp from "images/icons/arrow-up-full.svg";
import ArrowDown from "images/icons/arrow-down-full.svg";

type SortDirection = "asc" | "desc";

interface SortingArrowsProps {
  type: string;
  activeSort: { type: string; direction: "asc" | "desc" } | null;
  onChange: (type: string, dir: SortDirection) => void;
}

export default function SortingArrows({ type, activeSort, onChange }: SortingArrowsProps) {
  const isActive = (dir: SortDirection) => activeSort?.type === type && activeSort?.direction === dir;

  return (
    <div className="sorting-arrows">
      <button
        onClick={() => {
          onChange(type, "asc");
        }}
        className={`sorting-arrows__item ${isActive("asc") ? "sorting-arrows__item--active" : ""}`}
      >
        <ArrowUp />
      </button>
      <button
        onClick={() => {
          onChange(type, "desc");
        }}
        className={`sorting-arrows__item ${isActive("desc") ? "sorting-arrows__item--active" : ""}`}
      >
        <ArrowDown />
      </button>
    </div>
  );
}
